// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"111":"f5e963a8","292":"458d6a08","872":"1b52247d"}[chunkId] + ".css";
};